import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import indexOf from 'lodash/indexOf';
export default {
  name: 'NiotaClassicDevicesUploadEditForm',
  props: {
    editCols: {
      type: Object,
      required: false,
      default: null
    },
    applications: {
      type: Array,
      default: new Array()
    },
    originators: {
      type: Array,
      default: new Array()
    },
    deviceTypes: {
      type: Array,
      default: new Array()
    }
  },
  data: function data() {
    return {
      filterCols: ['applicationId', 'originatorId', 'originator', 'deviceTypeId', 'properties', 'otaa', 'error', 'valid', 'add', 'cType', 'msg']
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    filteredEditCols: function filteredEditCols() {
      var _this = this;

      return Object.keys(this.editCols).filter(function (col) {
        var index = indexOf(_this.filterCols, col);

        if (index === -1) {
          return col;
        }
      });
    }
  }),
  methods: {
    updateOtaa: function updateOtaa($event, item) {
      this.$emit('update-otaa', $event, item);
    },
    updateOriginatorId: function updateOriginatorId(item) {
      this.$emit('update-originator-id', item);
    },
    filterItems: function filterItems(item, queryText) {
      return item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    }
  }
};